import { types } from 'mobx-state-tree'
import { QuestionPctCorrectSummary } from './QuestionPctCorrectSummary'

export const UserQuestionKnowledgeGaps = types.model('UserQuestionKnowledgeGaps').props({
  strongestQuestions: types.array(QuestionPctCorrectSummary),
  weakestQuestions: types.array(QuestionPctCorrectSummary),
})
